import Vue from 'vue';

import filterMixin  from './com/urCommonGridFilterMixin';
import exportMixin  from './com/urCommonGridExportMixin';
import cellActMixin from './com/urCommonGridCellActMixin';
import copyMixin    from './com/urCommonGridCopyMixin';

//import  from '../config/urDataGridDefaultData';
//import {DEFAULT_DATA,CONST_VALUE}  from '../config/urDataGridConst';
import {DEFAULT_DATA,CONST_VALUE} from '../config'
import {copyObj, dateToText, isNull, getKey} from "../util"

// for notification - TODO make notiMixin... 로직이 좀 지저분한데?
const NOTI_DEFAULT = {
    msg  : '', key: null,
    type : 'log', // info, log, warn, error
    time : 5, // 4s
    hour : true,
    blur : false, // is Blur strated...
    tmSuicide : null, // Suicide timer...
}
/*WARNING*/ var notiCnt = 0;

// same logic between dGrid & fGrid
export default {
    mixins: [filterMixin, exportMixin, cellActMixin, copyMixin],
    data() {return {
        mx_fieldsInfo  : [],
        mx_dataFields  : [],
        mx_freezeFields: [],
        
        mx_options     : {},
        mx_refs        : {},
        
        mx_notiArr : [],
        
        mx_fieldMap : new Map(),
        mx_eventBus : new Vue(),
        
        vars_keyField     : null,
        vars_tableWidth   : 0,
        vars_freezeWidth  : 0,
        vars_freezeCount  : 0,
        vars_isFreeze     : false,
        vars_headerContext: null,
        vars_onBlocking   : false,
        vars_resizeGuide  : 0,
        
        // MESSAGE
        vars_messages : [],
        vars_msgMap : new Map(),
        
        mx_pager : {
            rowsPerPage: 10,
            currentPage: 1,
            totalPages: 0,
            totalItems: 0,
            //-----for calculating
            firstIndex: 0,
            oldPerPage: 0
        },
    }},
    computed : {
        // [COPMUTED][VARS] window row
        vars_windowRow() {
            return ~~(this.mx_options.height / this.mx_options.rowHeight)+1; 
        },
        // [COMPUTED][FLAG] is internal page
        isExternalPage() {
            return this.mx_options.pagination && !this.mx_options.internalPaging
        },
        // [COMPUTED][FLAG] is vertical accordion
        vars_accordionVert() {
            var opts = this.mx_options,
                isFreeze = !!this.vars_freezeWidth;
            if(!!opts.accordion) {
                if(isFreeze) return true;
                if(!opts.groupHeader && opts.accordionVertical) return true;
                if(!opts.groupHeader && opts.groupMerge) return true;
            }
            return false
        },
        // [COMPUTED][OBJ] Caller 
        mx_caller() {
            return this.$parent.$_caller || this.$parent
        }
    },
    watch : {
        options : {immediate: true, deep: true, handler(v) {
            /*TEST CODE*/console.debug('[COMMON] watch.mx_opts :',this.__i4=1+(this.__i4||0));
            this.mx_buildOptions(v);
        }},
        headers : {immediate: true, deep: true, handler(v) {
            /*TEST CODE*/console.debug('[COMMON] watch.mx_cols :',this.__i6=1+(this.__i6||0));
            this.mx_setHeaders(v);
        }},
        vars_dataSize : { immediate: true, handler(v,w) {
            /*TEST CODE*/console.debug('[COMMON] watch.vars_dataSize('+v+','+w+') :',this.__i15=1+(this.__i15||0));
            this.mx_pager.totalItems = v;
        }},
        "mx_pager.rowsPerPage":{immediate: true, handler(v, w) {
            // 1. recalc pager.currentPage
            var pager = this.mx_pager
            var firstIdx= (pager.currentPage-1)*w;
            var newPage = ~~(firstIdx/v)+1;
            pager.currentPage = newPage;
            pager.firstIndex = (newPage-1)*v;
            pager.oldPerPage = w;
            // 2. emit event
            if(w !== undefined) { // 초기 로딩시 발생 방지 - 이전값이 undefined 인 예외 경우가 있을까?
                this.mx_fireEvent('paging',this.mx_pager);
            }
        }}
    },
    created() {
        // CHEAT! WATCHOUT!, make "noti" function easier. 안타깝게도 이건 나만 쓸꺼임 ㄲㄲ
        this.noti = this.noti || {};
        this.noti.hello = () => {console.debug("HELLO")}
        this.noti.info = (v) => {this.mx_gridNoti({msg:v,type:"info"})}
        this.noti.succ = (v) => {this.mx_gridNoti({msg:v,type:"success"})}
        this.noti.pass = (v) => {this.mx_gridNoti({msg:v,type:"success"})}
        this.noti.warn = (v) => {this.mx_gridNoti({msg:v,type:"warn"})}
        this.noti.fail = (v) => {this.mx_gridNoti({msg:v,type:"error"})}
        this.noti.err  = (v) => {this.mx_gridNoti({msg:v,type:"error"})}
    },
    methods : {
        //----------------------------------------------------------
        //---  [METHOD] Initialize field infomation.             ---
        //----------------------------------------------------------
        mx_setHeaders(_v) {
            /*TEST CODE*/console.debug('[COMMON] methods.mx_setHeaders :',this.__i21=1+(this.__i21||0));
            if(!_v || (!Array.isArray(_v) && typeof _v !== 'function')) {
                this.mx_fieldsInfo = [];
                this.mx_fieldMap.clear();
                return;
            }
            // 1. Copy from props
            // TODO 속도 갱신할 수는 있는데 헤더쪽은 의미는 없을꺼 같은...
            // [perf] 영끌 가능
            this.mx_fieldMap.clear();
            var v = _v;
            if(typeof v === 'function') {v = v();}
            this.mx_fieldsInfo = v.map((c, idx) => {
                if(!c.value) {c.value = getKey('FIELD')} // check sideEffect
                var copied = copyObj(DEFAULT_DATA.FIELD);
                copyObj(copied, c);
                this.mx_fieldMap.set(c.value, copied);
                return copied;
            });
            // 2. Calculation
            // 2.1 Width
            this.mx_setHeaders_calcWidth      (this.mx_fieldsInfo);
            // 2.2 Find key field
            this.mx_setHeaders_calcKeyField   (this.mx_fieldsInfo);
            // 2.3 Additional flags
            this.mx_setHeaders_calcAddFlags   (this.mx_fieldsInfo);
            // 2.4 Check col freeze
            this.mx_setHeaders_calcColFreeze  (this.mx_fieldsInfo);
            // 2.5 Make custom class
            this.mx_setHeaders_calcCustomClass(this.mx_fieldsInfo);
            // 2.6 Build domain map for 'code' field
            this.mx_setHeaders_calcDomainMap  (this.mx_fieldsInfo);
            // 2.7 Process about validation
            this.mx_setHeaders_processValid   (this.mx_fieldsInfo);
            // 2.8 Build header position(cache)
            this.mx_setHeaders_posBuilder     (this.mx_fieldsInfo);
            // 3. Build array
            // 3.1 Split freeze/scroll array
            this.mx_splitField();
            // 3.2 Make forced sort columns array (for grouping)
            this.mx_buildForcedInfo();
        },
        mx_setHeaderAttr(fieldKey, attr, value) {
            var field = this.headers.find(f=>f.value === fieldKey);
            if(!field) return
            //field[attr] = value;
            this.$set(field, attr, value);
            // GO TO watch.headers(deep)
        },
        //----------------------------------------------------------
        //---  [METHODS] Local function of setHeaders methods.   ---
        //----------------------------------------------------------
        // 2.1 [LOCAL]calc : width
        mx_setHeaders_calcWidth(fields) {
            var perCent = 0;
            // 2.1.1 Iteration width
            var w = fields.reduce((acc,f,i,l)=> {
                // 2.1.1.1 set width to fields
                this.$set(f,'__idx'    ,i);
                this.$set(f,'__width'  ,f.width || null);
                this.$set(f,'__posLeft',null);
                // 2.1.1.2 is Percent? -> set table width
                if(f.width && f.width.slice && f.width.slice(-1) ==='%') {
                    perCent+= parseInt(f.width);
                }
                // 2.1.1.3 return value(check hide)
                if(f.hide) return acc+1; // 언제 들킬까? 이거? ㅋ
                return acc + ((~~f.width) || this.mx_options.defaultFieldWidth);
            }, 0);
            // 2.1.2 Add util column - Checkbox(first)
            w += this.mx_options.selectCheck ? this.mx_options.selectCheckboxWidth : 0;
            // 2.1.3 Add util column - Accordion expand
            w += !!this.mx_options.accordion ? this.mx_options.accordionColumnWidth: 0;
            // 2.1.3 scaleUp for % fields // 지금은 딱히.. 안쓸껄? %는 베타 기능임
            w /= (100-perCent)/100;
            // 2.1.x set to variable
            this.vars_tableWidth = w;
        },
        // 2.2 [LOCAL]calc : key field
        mx_setHeaders_calcKeyField(fields) {
            fields.find(f => {
                // 2.2.1 jump to next
                if(!f.key) return false; 
                // 2.2.2 I FIND KEY!
                this.vars_keyField = f.value;
                // 2.2.3 finish loop (Array.find)
                return true;
            });
            if(this.mx_dataSet) {
                // for Data-grid
                this.mx_dataSet.setKeyField(this.vars_keyField);
            }
        },
        // 2.3 [LOCAL]calc : additional flags
        mx_setHeaders_calcAddFlags(fields) {
            var grps = this.mx_options.grouping, isGrps = !isNull(grps);
            
            fields.forEach(f => {
                // 2.3.1 normal fields
                f.__isSort    = !!f.sort;
                f.__isCustomSort = typeof f.sort === 'function';
                // 2.3.2 reactive fields
                if(this.mx_options.accordion) {
                    this.$set(f,'__accordion',false);
                }
                this.$set(f,'__filterValue',null);
                this.$set(f,'__sortOrder',''); // [''|'A'scend|'D'ecend]
                // 2.3.3 skip Editing - '__' field is only for grid. 
                if( f.value.startsWith('__') ) {
                    f.readonly = true;
                }
                // 2.3.4 filter checker
                f.__isFilter  = !!f.filter;
                f.__filterChecker = this.mx_filter_getChecker(f);
                
                // 2.3.5 grouping?
                if(isGrps) {
                    this.$set(f,'__isGroup',grps.indexOf(f.value));
                }
            });
        },
        // 2.4 [LOCAL]calc : Column freeze
        mx_setHeaders_calcColFreeze(fields) {
            // 2.4.0 Block freeze!!
            if(this.mx_options.blockFreeze) {
                this.vars_isFreeze = false;
                this.vars_freezeWidth = 0;
                this.vars_freezeCount = 0;
                return;
            }
            // 2.4.1 EXCEPTION!! If all field is freeze?
            if(fields && fields.reduce((acc,fil)=>acc+(fil.freeze?1:0),0) === fields.length) {
                console.warn('[UIDEV] All header fields are freezed. Ignore it.')
                fields.forEach(fil => fil.freeze = false);
            }
            // 2.4.1 Sum freeze column width
            var freezeWidth = 0, freezeCount;
            /*NOSONAR*/fields.find((f, idx) => {
                if(!f.freeze) {freezeCount = idx; return true;}
                if(f.hide) {freezeWidth++;return false;}
                // freeze column doesn't allow strech
                if(!f.__width) f.__width = this.mx_options.defaultFieldWidth;
                // TODO freeze column with percent
                freezeWidth+= parseInt(f.__width);
                return false;
            });
            var freezeFlag = true;
            /*NOSONAR*/fields.forEach(f=>{
                freezeFlag = freezeFlag && f.freeze;
                this.$set(f,'__frz',freezeFlag);
            })
            // 2.4.2 If some column freeze? Checkbox will be freeze too.
            if(freezeWidth > 0 && this.mx_options.selectCheck) {
                freezeWidth += this.mx_options.selectCheckboxWidth;
            }
            // 2.4.3 If accordion is active? Accordion will be freeze too.
            if(freezeWidth > 0 && this.mx_options.accordion) {
                freezeWidth += this.mx_options.accordionColumnWidth;
            }
            // 2.4.4 set to vars
            this.vars_isFreeze    = fields && fields.length && !!fields[0].freeze;
            this.vars_freezeWidth = freezeWidth;
            this.vars_freezeCount = freezeCount;
        },
        // 2.5 [LOCAL]calc : Custom class 
        mx_setHeaders_calcCustomClass(fields) {
            /*NOSONAR*/fields.forEach(f => {
                // 2.5.1 Is custom?
                if(!f.customClass) {return}
                // 2.5.2 Normalize Arguments... ( "" || [] ) => ['clazz-1', 'clazz-2', ...]
                var arr = [], cz = f.customClass;
                if(typeof cz === 'string') {
                    this.$set(f, '__cuzClass',cz.split(/\s+/))
                } else if (Array.isArray(cz)) {
                    this.$set(f, '__cuzClass',cz)
                
                // customClass를 사용하기 위해 수정 (2022.04.29 aaron.sun)
                // } else if (typeof cz === 'function') {
                //     f.__fnClass = cz;
                // }                
                } else if (typeof cz === 'function') {
                    this.$set(f, '__fnClass',cz)
                }

                // TODO function type custom class?
            })
        },
        // 2.6 [LOCAL] build domain map for 'code' field
        mx_setHeaders_calcDomainMap(fields) {
            /*NOSONAR*/fields.forEach(f=> {
                this.$set(f,'__domainMap',undefined); // [perf] 영끌 가능
                // 2.6.1 Check not target
                if(f.type !== 'code') return;
                if(!f.domain) return;
                if(!f.domain.length || typeof f.domain[0] !== 'object') return;
                // 2.6.2 build domainMap
                var m = new Map(), n = new Map();
                f.domain.forEach(d => {
                    m.set(d.value, d);
                    n.set(d.text.trim(), d);
                });
                this.$set(f,'__domainMap',m);
                this.$set(f,'__cotextMap',n);
            })
        },
        // 2.7 [LOCAL] Process about validation
        mx_setHeaders_processValid(fields) {
            const opts = this.mx_options;
            /* NOSONAR */fields.forEach(f => {
                let rules = [], msg;
                // 2.7.1 check required
                if(f.required) {
                    rules.push((v) => (v!==undefined && v!==null && v!=='') || opts.msgValidRequired.replace('$',f.text||f.value))
                }
                // 2.7.2 check rules
                // TODO f.rules : Check array, Check not empty array
                if(f.rules) {
                    if(typeof f.rules === 'function') {
                        rules.push(f.rules);
                    } else if(Array.isArray(f.rules)) {
                        rules.push(...f.rules);
                    }
                }
                // 2.7.3 check min/Max
                if(f.min) {
                    switch(f.type) {
                    case 'string':
                        rules.push((v) => !v || v.length>=f.min ||
                                opts.msgValidMinLength.replace('$',f.text||f.value).replace('#',f.min))
                        break;
                    case 'date':
                        const fmt = f.dateFormat || opts.dateFormat;
                        const timezone = f.timezone===null ? opts.timezone : f.timezone;
                        rules.push((v) => !v || v>=f.min        ||
                                opts.msgValidMinValue.replace('$',f.text||f.value).replace('#',dateToText(f.min, fmt, timezone)))
                        break;
                    case 'number':
                        rules.push((v) => !v || v>=f.min        ||
                                opts.msgValidMinValue.replace('$',f.text||f.value).replace('#',f.min))
                        break;
                    }
                }
                if(f.max) {
                    switch(f.type) {
                    case 'string':
                        rules.push((v) => !v || v.length<=f.max  ||
                                opts.msgValidMaxLength.replace('$',f.text||f.value).replace('#',f.max));
                        break;
                    case 'date':
                        const fmt = f.dateFormat || opts.dateFormat;
                        const timezone = f.timezone===null ? opts.timezone : f.timezone;
                        rules.push((v) => !v || v<=f.max ||
                                opts.msgValidMaxValue.replace('$',f.text||f.value).replace('#',dateToText(f.max, fmt, timezone)))
                        break;
                    case 'number':
                        rules.push((v) => !v || v<=f.max ||
                                opts.msgValidMaxValue.replace('$',f.text||f.value).replace('#',f.max))
                        break;
                    }
                }
                // 2.7.x set to __rules
                if(rules.length) {
                    this.$set(f,'__rules',rules);
                }
            })
        },
        // 2.8 [LOCAL] Build header position(cache)
        mx_setHeaders_posBuilder(fields){
            const dWI = this.mx_options.defaultFieldWidth;
            const CBW = this.mx_options.selectCheckboxWidth;
            var pox = 0, pob = 0, pop = 0, wip = 0;
            // 1. check first
            if(this.mx_options.selectCheck) {
                pox += CBW;
            }
            // TODO PERCENTAGE WIDTH, pop, wip
            fields.forEach(f=>{
                // 1. Cache position
                this.$set(f, '__pox', pox)
                this.$set(f, '__pob', pob)
                // 2. Build value
                if(f.hide)        {pox++;}
                else if(f.__width){pox+= f.__width}
                else if(f.__frz)  {pox+= dWI}
                else              {pob++}
            });
        },
        // 3.1 [LOCAL] Split freeze/scroll array
        mx_splitField() {
            // 3. Split array
            var freezeFlag = true;
            this.mx_dataFields   = [];
            this.mx_freezeFields = [];
            for(var i=0, ii=this.mx_fieldsInfo.length; i<ii; i++ ) {
                var f = this.mx_fieldsInfo[i];
                freezeFlag = freezeFlag && f.freeze && !this.mx_options.blockFreeze;
                if(freezeFlag) {this.mx_freezeFields.push(f)}
                else           {this.mx_dataFields.push(f)}
            }
        },
        // 3.2 [LOCAL] Make forced sort columns array (for grouping)
        mx_buildForcedInfo() {
            var grps = this.mx_options.grouping;
            
            if(isNull(grps)) return;
            grps.forEach( g => {
                var f = this.mx_fieldMap.get(g);
                if(!f) return;
                // 1. Set sort info
                this.mx_sort_forced.push(f);
                // 2. Set filter info
                this.mx_filter_forced.push({
                    value  : f.value,
                    data   : null,
                    checker: this.mx_filter_getChecker(f)
                })
            });
        },/**/
        // [METHOD] Get field info with field key.
        mx_getField(fieldKey){
            return this.mx_fieldMap.get(fieldKey);
        },
        // [METHOD] Make default value object
        mx_setHeaders_makeDefaultObj(){
            const fields = this.mx_fieldsInfo;
            const optDefRow = this.mx_options.defaultValue || {};
            var obj = {}
            fields.forEach(f => {
                if(typeof f.defaultValue === 'function') {
                    obj[f.value] = f.defaultValue();
                } else if(f.defaultValue !== undefined && f.defaultValue !== null) {
                    obj[f.value] = f.defaultValue;
                } else if(typeof optDefRow[f.value] === 'function') {
                    obj[f.value] = optDefRow[f.value]();
                } else if(optDefRow[f.value] !== undefined) {
                    obj[f.value] = optDefRow[f.value];
                }
            });
            return obj;
        },
        //----------------------------------------------------------
        //---  [METHOD] Build options                            ---
        //----------------------------------------------------------
        mx_buildOptions(_v) {
            /*TEST CODE*/console.debug('[COMMON] methods.mx_buildOptions :',this.__i22=1+(this.__i22||0));
            // 0. If v is empty
            if(!_v) {
                this.mx_options = Object.assign({},DEFAULT_DATA.OPTS);
                return;
            }
            var v = _v
            // 1. Adjust option
            // 1.1 [infinityScroll]
            // 1.1.1 Pagination make disable infinity scroll
            if(v.pagination) {
                v.infinityScroll = false;
            }
            // 1.1.2 Infinity scroll make height(if it's not set)
            if(v.infinityScroll) {
                if(!v.height) {
                    v.height = CONST_VALUE.VAL.DEFAULT_HEIGHT;
                }
            }
            // 1.2 [editable]
            // 1.2.1 editable
            if(v.editable) {
                if(v.cellMode) {
                    v.cellEdit = true;
                } else {
                    v.rowEdit = true;
                }
            }
            
            // 1.3 [selectCheck & Only]
            // 1.3.1 "Only" option also make true 'selectCheck'
            if(v.selectCheckOnly) { 
                //v.selectCheck = true;
            }
            
            // 1.4 [grouping]
            // 1.4.1 normalize option
            if(v.grouping) {
                if(typeof v.grouping === 'string') {
                    // we don't want to string type value
                    v.grouping = [v.grouping]; // and It's not good pattern too.
                }
            }
            // 1.4.2 When active this options... some rules
            if(!isNull(v.grouping)) {
                // 1.4.2.1 "Click mode" is fixed to 'default'
                v.clickMode = 'default';
                // 1.4.2.2 "Group header" makes ignore 'freeze'
                if(v.groupHeader) {
                    v.blockFreeze = true;
                }
                // 1.4.2.3 "Group merge" makes ignore 'row edit'
                if(v.groupMerge) {
                    v.rowEdit = false;
                }
            }
            
            // 1.5 [cellMode/Edit]
            // 1.5.1 adjust flag
            if(v.cellEdit) {
                v.cellMode = true 
            }
            //if(v.cellMode && v.editable ) {}
            if(v.cellMode) {
                v.selectCheckOnly = true;
            }
            
            // 1.6.1 [DateFormat]
            if(v.dateFormat && !v.dateEditFormat) {
                v.dateEditFormat = v.dateFormat;
            }
            
            // 2. make real options.. copy deep?
            this.mx_options = Object.assign({},DEFAULT_DATA.OPTS, v);
            // 3. after adjust
            // 3.1 [pagination]
            if(v.pagination) {
                this.mx_pager.rowsPerPage = this.mx_options.defaultPageSize
            }
            // Re-calculation field's width
            this.mx_recalcFieldWidth(!!this.vars_freezeWidth);
        },
        //----------------------------------------------------------
        //---  [METHOD] Other functional methods...              ---
        //----------------------------------------------------------
        // [METHOD] Set refs for all, not reactive
        mx_setRefs(key,obj) {
            this.$set(this.mx_refs,key,obj);
        },
        // [METHOD] It makes grid event, for consumer
        mx_fireEvent(/*evtName,...args*/) {
            var args = Array.from(arguments);
            if(!args.length) return;
            const PREFIX = "grid:";//this.mx_options.eventPrefix
            args[0] = PREFIX+args[0]
            this.$emit(...args);
        },
        // [METHOD] Set header context & open it
        mx_setHeaderCtx(field) {
            this.vars_headerContext = field || null;
        },
        // [METHOD] Grid notification 
        mx_gridNoti(val) {
            // 1. set default value
            let _noti;
            if(typeof val === 'string') {
                _noti=Object.assign({},NOTI_DEFAULT,{msg:val});
            } else/* if (typeof val === 'object')*/ {
                _noti=Object.assign({},NOTI_DEFAULT,val);
            }
            _noti.key = notiCnt++;
            // 2. set Blur, Timer
            _noti.tmSuicide = setTimeout(() => {
                _noti.blur = true;
                // 3. set Suicide, timer change
                _noti.tmSuicide = setTimeout(() => {
                    this.mx_notiArr.find((v,i) => {
                        if(v !== _noti) {return false;}
                        this.mx_notiArr.splice(i,1);
                        return true;
                    })
                },2000);
            },5000); // @see .ur-data-grid__noti-item__hourglass/**/
            this.mx_notiArr.unshift(_noti);
        },
        // [METHOD] Grid blocker. Unfortunately, grid cannot use this
        mx_toggleBlock(flag) {
            if(flag!==undefined) {
                this.vars_onBlocking = !!flag;
            } else {
                this.vars_onBlocking = !this.vars_onBlocking
            }
        },
        // [METHOD] Set field's width
        mx_setFieldWidth(field, width) {
            // 1. set widt
            field.width = width; // TODO get field with field.value & set width? is better?
            // 2. re-calc
            this.mx_recalcFieldWidth();
            // 3. check width?
            const RIGHTS_OF_CONTENT = 100; //스크롤컨텐츠 영역에 100px을 보장하라! 
            var elRect = this.$el.getBoundingClientRect(),
                offset = this.vars_freezeWidth - elRect.width + RIGHTS_OF_CONTENT
            if(offset > 0) { // 으앙 터짐!
                // ... 다시함.
                field.width = width - offset;
                // ... ㅇㅇ, 다시함.
                this.mx_recalcFieldWidth();
            }
        },
        // [METHOD] Re-calculation field's width
        mx_recalcFieldWidth(freezeFlag){
            // 이거 매개변수 꼭 필요함?
            this.mx_setHeaders_calcWidth    (this.mx_fieldsInfo);
            this.mx_setHeaders_calcColFreeze(this.mx_fieldsInfo);
            this.mx_setHeaders_posBuilder   (this.mx_fieldsInfo);
            if(freezeFlag){
                this.mx_splitField();
            }
            // x. send to children
            this.$nextTick(()=>{this.mx_eventBus.$emit('recalc-width')});
        },
        // [METHOD] Set resize-guide position
        mx_setResizerPos(pos) {
            this.vars_resizeGuide = pos;
        },
        // [METHOD] Open context menu
        mx_openContext(val, row, ctxs, pos) {
            var $ctx = this.mx_refs.context;
            if($ctx) {
                $ctx.open(val, row, ctxs, pos);
            }
        },
        // [METHOD] Call Event-bus
        mx_ebusEmit(key, a,b,c,d,e) {
            this.mx_eventBus.$emit(key,a,b,c,d,e)
        },
        
        //------------ ERR MESSAGE ---------------
        // [METHOD] validation message from outer
        //rowId, fieldKey, text, _type
        mx_setErrMsg(msgArr/*or Row-ID*/, fieldKey, text, _type) {
            // 1. check value
            if(!msgArr) return;
            if(Array.isArray(msgArr)) {
                // case 2. Array setting.
                msgArr.forEach(msg => {
                    const ID = msg.__id;
                    for(var k in msg) {
                        if(k==='__id') continue;
                        this.mx_setErrMsg(ID, k, msg[k], 'error');
                    }
                });
            } else {
                // case 3. Set single message
                const row = this.mx_getRow(msgArr/* ===rowId */);
                const fil = this.mx_fieldMap.get(fieldKey);
                this.mx_addCellMsg(text, row, fil, _type);
            }
        },
        // [METHOD] validation message from outer
        mx_resetErrMsg(rowId, fieldKey) {
            const row = this.mx_getRow(rowId);
            const fil = this.mx_fieldMap.get(fieldKey);
            this.mx_delCellMsg(row, fil);
        },
        //------------ SCROLL ---------------
        // [METHOD] scroll with field key
        mx_setScrollField(fieldKey) {
            var diff = 0;
            // 1. caclulation
            //    !! only for data fields(scroll area) 
            var res = this.mx_dataFields.find(f => {
                // 1.1 Check first cell
                if(f.value === fieldKey) {return true;}
                // 1.2 Add diff
                diff += f.__width || this.mx_options.defaultFieldWidth;
                return false;
            });
            // 2. move scroll
            if(res === undefined) {return null}
            this.mx_eventBus.$emit('set-scroll-left', diff)
            return diff;
        },
        // [METHOD] Open context menu
        mx_setScrollRow(rowIdx){
            // 1. Calc height
            var diff = rowIdx * this.mx_options.rowHeight;
            // TODO need accordion calculation
            // 2. Check overflow?
            var sw = this.mx_refs.scrollWrapper;
            var max = sw.scrollHeight, win = sw.clientHeight;
            if(diff > max - win) {diff = max-win}
            
            // 3. Set scroll top
            this.mx_eventBus.$emit('set-scroll-top', diff)
            
            // x. return actual scroll
            return diff;
        },
        //------------ SCROLL ---------------
        // [METHOD] scroll with field key
        mx_addCellMsg(txt, row, fil, _type) {
            const KEY = row.__id +"_"+fil.value;
            if(this.vars_msgMap.has(KEY)) {
                if(txt === this.vars_msgMap.get(KEY).text) return;
                this.mx_delCellMsg(row,fil);
            }
            var type = _type || 'error';
            var data = {
                key   : KEY,
                row   : row,
                field : fil,
                text  : txt,
                type  : type
            }
            this.vars_msgMap.set(KEY, data)
            this.vars_messages.push(data);
        },
        // [METHOD] scroll with field key
        mx_delCellMsg(row, fil) {
            if(!row && !fil) {
                this.vars_messages = [];
                this.vars_msgMap.clear();
            } else if(fil) {
                // 1. If field
                const KEY = row.__id +"_"+fil.value;
                if(!this.vars_msgMap.has(KEY)) return;
                var idx = this.vars_messages.findIndex(m => m.key === KEY)
                this.vars_messages.splice(idx, 1)
                this.vars_msgMap.delete(KEY);
            } else {
                // 2. If no field
                this.vars_messages = this.vars_messages.filter(m => {
                    if(m.row.__id !== row.__id) {return true}
                    this.vars_msgMap.delete(m.KEY);
                    return false;
                });
            }
        },
        //------------ CONFIG ---------------
        // [METHOD] Open header config context
        mx_openHeaderConfig() {
            this.mx_eventBus.$emit('open-header-config')
        },
        mx_closeHeaderConfig() {
            this.mx_eventBus.$emit('close-header-config')
        },
        
        //------------ PAGER ---------------
        // [METHOD] Control current page index
        mx_setCurrPage(idx) {
            // 1. Move and recalc page
            let _p = this.mx_pager;
            _p.currentPage = idx;
            _p.firstIndex = (idx-1)*_p.rowsPerPage;
            // 2. Redraw data
            if(this.mx_options.internalPaging) {
                this.mx_buildViewData();
            }
            // 3. Event
            this.mx_fireEvent('paging',this.mx_pager);
        },
    }
}

